import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Sentence, Dropdown } from '../_shared';
import classNames from 'classnames';
import { Fade } from 'react-reveal';

import './naturallanguage.scss';

@inject('store')
@observer
export class NaturalLanguageComponent extends Component {
    onChange(e, questionID, isMultiple) {
        const { store } = this.props,
            value = e.target.value;

        store.addValue(questionID, isMultiple, value);
        store.updateItems(store.questions);
        store.updateItems(store.answers);
    }

    renderOptions(options) {
        const result = options.map((option) => {
            return {
                value: option.id,
                label: option.title
            };
        });

        return result.length > 0 ? result : [];
    }

    renderQuestion(question, renderCurrent, firstQuestion) {
        const { store } = this.props,
            index = store.queryValues.length > 0 ? store.queryValues.findIndex(obj => obj.question === question.id) : -1,
            options = this.renderOptions(question.Options.nodes),
            multiple = question.type === 'MultiSelect',
            wrapperClasses = classNames('naturallanguage-sentence__wrapper', {
                'naturallanguage-sentence__wrapper--clear': question.newLine && question.Show
            });

        if (index === -1 && question.Show && !renderCurrent) {
            return '';
        }

        let defaultValue = question.type === 'MultiSelect' ? [] : '',
            value = index > -1 ? store.queryValues[index].option : defaultValue,
            sentence = <Sentence
                key={question.id}
                name={question.id}
                prefix={question.prefixText}
                sufix={question.suffixText}
                dropdown={<Dropdown
                    name={`${question.id}Select`}
                    source={options}
                    label={question.label ? question.label : 'Select an option'}
                    placeholder={question.placeholder ? question.placeholder : 'select'}
                    onChange={(event) => this.onChange(event, question.id, multiple)}
                    value={value}
                    multiple={multiple}
                />}
                disabled={store.queryValues[index] ? (store.queryValues[index].option || false) : false}
                displayLogic={question.Show}
            />;

        if (firstQuestion) {
            return sentence;
        }

        return <Fade key={question.ID} bottom delay={renderCurrent ? 250 : 0} distance={!renderCurrent ? '25%' : '100%'}>
            <div className={wrapperClasses}>
                {sentence}
            </div>
        </Fade>;
    }

    renderCurrentQuestion(questions) {
        const { store } = this.props,
            question = questions.find(question => {
                const index = store.queryValues.length > 0 ? store.queryValues.findIndex(obj => obj.question === question.id) : -1;
                if (question.Show && index === -1) {
                    return question;
                }
            });

        return question ? this.renderQuestion(question, true, store.queryValues.length === 0) : '';
    }

    renderLoader() {
        return <section className='wrap wrap--inherit naturallanguage-wrap naturallanguage-wrap--loader'>
            <span className='loader loader--ondark'>
                <span className='loader-text'>Loading</span>
            </span>
        </section>;
    }

    renderAllQuestions() {
        const { store } = this.props;

        return <section className='wrap wrap--inherit'>
            <div className='naturallanguage-container container'>
                <div className='pure-g pure-g--centered'>
                    <div className='pure-u-1 pure-u-md-9-12 pure-u-lg-8-12'>
                        <div className='naturallanguage-phrasewrap'>
                            <div className='transition-in-up'>
                                <div className='naturallanguage-phrase'>
                                    {store.questions.map(question => this.renderQuestion(question, false, false))}
                                </div>
                                <div className='naturallanguage-currentquestion'>
                                    {this.renderCurrentQuestion(store.questions)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>;
    }

    renderCurrentAnswer(answers) {
        const currentAnswer = answers.find(answer => {
            if (answer.Show) {
                return answer;
            }
        });

        return currentAnswer ? this.renderAnswer(currentAnswer) : '';
    }

    contentError() {
        return <div className='alert alert--success alert--large'>
            <div className='alert-container container'>
                <span className='alert-heading alert-heading--large'>
                    Sorry
                </span>
                <span className='alert-text alert-text--large'>
                    &mdash; Your result is temporarily unavailable. Please check back soon.
                </span>
            </div>
        </div>;
    }

    renderAnswer(answer) {
        if (!answer.title && !answer.content && !answer.queryLink) {
            return this.contentError();
        }
        return <section className='wrap wrap--light wrap--pb2'>
            <div className='container'>
                <div className='pure-g pure-g--centered'>
                    <div className='pure-u-1 pure-u-md-9-12 pure-u-lg-8-12'>
                        <div className='transition-in-up'>
                            { answer.title && <h2>{answer.title}</h2>}
                            { answer.content && <div className='spacer-md naturallanguage-content' dangerouslySetInnerHTML={{
                                __html: answer.content
                            }} />}
                            { answer.queryLink && <div dangerouslySetInnerHTML={{
                                __html: answer.queryLink
                            }} />}
                        </div>
                    </div>
                </div>
            </div>
        </section>;
    }

    renderQueries() {
        const { store } = this.props;

        return <div>
            {this.renderAllQuestions()}
            {this.renderCurrentAnswer(store.answers)}
        </div>;
    }

    render() {
        const { store } = this.props;

        return <div className='naturallanguage'>
            {(store.hasLogic && store.hydrated && store.questions) ? this.renderQueries() : this.renderLoader() }
        </div>;
    }
}